import { webAnalytics as wa } from '@principal/web-analytics';
import { useUserPreferences } from '../../../user-preferences/UserPreferencesProvider';
import Checkbox from '../../../shared/components/Checkbox/Checkbox';
import { ToggleType } from '../../../shared/models/WebAnalytics';

const RowSelector = () => {
  const { userPreferences, dispatch } = useUserPreferences();

  const onToggleZeroDollarCompensationAmount = () => {
    if (dispatch) {
      const newValue = !userPreferences?.includeZeroDollarCompensationAmount;
      dispatch({ type: 'include-zero-dollar-compensation-amount' });
      wa.trackEvent('pageNavigationClick', {
        clicktext: `Preferences-Rows-$0.00 Amount Paid-${newValue ? ToggleType.SHOW : ToggleType.HIDE}`,
        navigationsection: 'filter',
      });
    }
  };

  return (
    <>
      <h4>Rows to show</h4>
      <Checkbox
        checked={userPreferences?.includeZeroDollarCompensationAmount}
        id="checkbox-includeZeroDollarCompensationAmount"
        label="$0.00 Amount Paid"
        onChange={onToggleZeroDollarCompensationAmount}
        title="Show earnings where the amount paid was $0.00"
      />
    </>
  );
};

export default RowSelector;
